import { faro, genShortID } from '@grafana/faro-core';
export function createSession(attributes) {
    var _a, _b, _c, _d;
    return {
        id: (_d = (_c = (_b = (_a = faro.config) === null || _a === void 0 ? void 0 : _a.sessionTracking) === null || _b === void 0 ? void 0 : _b.generateSessionId) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : genShortID(),
        attributes,
    };
}
//# sourceMappingURL=createSession.js.map